var _path, _path2, _path3, _path4, _path5;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPhoneCall = function SvgPhoneCall(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 1.5H22.5V4.5H19.5V1.5Z",
    fill: "#F8F8F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 6H22.5V9H19.5V6Z",
    fill: "#F8F8F8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 1.5H18V4.5H15V1.5Z",
    fill: "#F8F8F8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 6H18V9H15V6Z",
    fill: "#F8F8F8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 22.5H18.6225C3.88503 21.6525 1.79253 9.2175 1.50003 5.4225C1.45431 4.82756 1.64679 4.23883 2.03512 3.78579C2.42346 3.33276 2.97584 3.05253 3.57078 3.00675C3.63028 3.00225 3.69003 3 3.75003 3H7.70253C8.00294 2.99971 8.29653 3.08963 8.54525 3.25812C8.79397 3.42661 8.98637 3.6659 9.09753 3.945L10.2375 6.75C10.3473 7.02266 10.3745 7.32156 10.3159 7.60957C10.2572 7.89758 10.1152 8.162 9.90753 8.37L8.31003 9.9825C8.55855 11.401 9.23732 12.7087 10.2543 13.7284C11.2712 14.748 12.5772 15.4302 13.995 15.6825L15.6225 14.07C15.8336 13.8646 16.1006 13.7259 16.39 13.6713C16.6794 13.6166 16.9785 13.6483 17.25 13.7625L20.0775 14.895C20.3524 15.0097 20.5869 15.2036 20.7512 15.452C20.9155 15.7004 21.0021 15.9922 21 16.29V20.25C21 20.8467 20.763 21.419 20.341 21.841C19.9191 22.2629 19.3468 22.5 18.75 22.5ZM3.75003 4.5C3.65154 4.4997 3.55395 4.51881 3.46284 4.55623C3.37173 4.59365 3.28889 4.64864 3.21904 4.71808C3.14918 4.78751 3.09369 4.87003 3.05573 4.96091C3.01776 5.05179 2.99807 5.14926 2.99778 5.24775C2.99778 5.26875 2.99778 5.289 3.00003 5.31C3.34503 9.75 5.55753 20.25 18.705 21C18.9035 21.0119 19.0986 20.9445 19.2474 20.8125C19.3962 20.6806 19.4866 20.495 19.4985 20.2965L19.5 20.25V16.29L16.6725 15.1575L14.52 17.295L14.16 17.25C7.63503 16.4325 6.75003 9.9075 6.75003 9.84L6.70503 9.48L8.83503 7.3275L7.71003 4.5H3.75003Z",
    fill: "#F8F8F8"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPhoneCall, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/phoneCall.82901ddd.svg";
export { ForwardRef as ReactComponent };